jQuery(document).ready(function ($) {
    function enableFormSubmitButton(event) {
        console.log(`${event.type}: enable`);

        if ($(this).find('.wpcf7-submit').attr('disabled') === 'disabled') {
            $(this).find('.wpcf7-submit').removeAttr('disabled');
        }
    }

    function disableFormSubmitButton(event) {
        console.log(`${event.type}: disable`);
        $(this).find('.wpcf7-submit').attr('disabled', '');
    }

    $(document).on({
        'change wpcf7statuschanged': enableFormSubmitButton,
        'submit': disableFormSubmitButton,
    }, '.wpcf7-form');

    $(document).on('submit wpcf7submit', '.wpcf7-form', function (event) {
        $(this).find('.wpcf7-response-output').css('display', '');
    })

    $(document).on('click', '.wpcf7-response-output', function (event) {
        $(this).fadeOut(500);
    });
});